import React, { useState } from "react";
import { CaseEventCategory } from "types/CivilTypes";
import {
  Form,
  Panel,
  Button,
  DataTable,
  DataTableColumn,
  Checkbox,
  HelpIconMode,
} from "@countysuite/ui";
import { getSelectedRows } from "../getSelectedRows";
import { HelpIconButton } from "components/HelpIconButton/HelpIconButton";

export interface Props {
  categories: CaseEventCategory[];
  selectedIDs: number[];
  onChangeSelectedIDs: (newSelections: number[]) => void;
  title: string;
  nextStep: () => void;
  onSave: () => Promise<boolean>;
  children?: React.ReactNode;
}

export const LackOfProsecutionCaseEventCategoriesPanel: React.FC<Props> = (
  props
) => {
  const [onlySelected, setOnlySelected] = useState(false);

  let tableData: CaseEventCategory[];
  if (onlySelected) {
    tableData = getSelectedRows(
      props.selectedIDs,
      props.categories,
      (caseCategory: CaseEventCategory) => caseCategory.id
    );
  } else {
    tableData = props.categories;
  }

  const tableColumns: DataTableColumn<CaseEventCategory>[] = [
    {
      Header: () => (
        <div style={{ textAlign: "left" }}>Docket Category Name</div>
      ),
      accessor: "name",
    },
  ];

  async function handleSubmit() {
    const success = await props.onSave();
    if (success) {
      props.nextStep();
    }
  }

  return (
    <Form onSubmit={handleSubmit} values={props.selectedIDs}>
      {({ handleSubmit }) => (
        <Panel
          title={props.title}
          buttons={
            <>
              <HelpIconButton mode={HelpIconMode.Modal}>
                {props.children}
              </HelpIconButton>
              <Button color="success" onClick={handleSubmit}>
                Save
              </Button>
            </>
          }
        >
          <Checkbox
            name="onlySelectedCaseCategories"
            checked={onlySelected}
            onChange={(e: any) => setOnlySelected(e.target.checked)}
          >
            Only show selected rows
          </Checkbox>
          <DataTable
            data={tableData}
            columns={tableColumns}
            keyField="id"
            onChangeSelections={props.onChangeSelectedIDs}
            selectedKeys={props.selectedIDs}
            ignoreSymbolsWhenFiltering
          />
        </Panel>
      )}
    </Form>
  );
};

(LackOfProsecutionCaseEventCategoriesPanel as any).displayName =
  "LackOfProsecutionCaseEventCategoriesPanel";
